import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const noop = () => {};
const SearchWithAutocompleteContext = /*#__PURE__*/createContext({
  options: [],
  listedOptions: [],
  selectedItem: null,
  setSelectedItem: () => null,
  selectedItemIndex: null,
  setSelectedItemIndex: noop,
  searchValue: '',
  setSearchValue: noop,
  clearSelection: noop,
  clearSearch: noop,
  hideResults: false,
  setHideResults: noop,
  userHasSearched: false,
  setUserHasSearched: noop
});
export const SearchWithAutocompleteProvider = ({
  options = [],
  searchValue: initialSearchValue = '',
  onSearch,
  children
}) => {
  const [forceHide, setForceHide] = useState(false);
  const [userHasSearched, setUserHasSearched] = useState(false);
  const [searchValue, setSearchValue] = useState(initialSearchValue);
  const [selectedItemIndex, setSelectedItemIndex] = useState(null);
  const listedOptions = useMemo(() => {
    let allOptions = new Array();
    options.forEach(option => {
      const optionsGroup = option;
      if (optionsGroup.options) allOptions = allOptions.concat(optionsGroup.options);else allOptions.push(option);
    });
    return allOptions;
  }, [options]);
  const setSelectedItem = useCallback(item => {
    let index = listedOptions.findIndex(({
      value
    }) => value === item.value);
    index = index > -1 ? index : null;
    setSelectedItemIndex(index);
    return index;
  }, [listedOptions]);
  const handleSetSelectedItemIndex = useCallback(index => {
    setSelectedItemIndex(index);
    return index === null ? null : listedOptions[index];
  }, [listedOptions]);
  const handleSetSearchValue = useCallback(value => {
    setSearchValue(value);
    onSearch === null || onSearch === void 0 || onSearch(value);
  }, [onSearch]);
  const clearSelection = useCallback(() => setSelectedItemIndex(null), []);
  const selectedItem = selectedItemIndex !== null ? listedOptions[selectedItemIndex] : null;
  const hideResults = !userHasSearched || forceHide || !searchValue || !(listedOptions !== null && listedOptions !== void 0 && listedOptions.length);
  const clearSearch = useCallback(() => {
    handleSetSearchValue('');
    clearSelection();
  }, [clearSelection, handleSetSearchValue]);
  const contextState = useMemo(() => ({
    options,
    listedOptions,
    selectedItem,
    setSelectedItem,
    selectedItemIndex,
    setSelectedItemIndex: handleSetSelectedItemIndex,
    searchValue,
    setSearchValue: handleSetSearchValue,
    clearSelection,
    clearSearch,
    hideResults,
    setHideResults: setForceHide,
    userHasSearched,
    setUserHasSearched
  }), [options, listedOptions, selectedItem, setSelectedItem, selectedItemIndex, handleSetSelectedItemIndex, searchValue, handleSetSearchValue, clearSelection, clearSearch, hideResults, userHasSearched]);
  return /*#__PURE__*/_jsx(SearchWithAutocompleteContext.Provider, {
    value: contextState,
    children: children
  });
};
export const useSearchWithAutocompleteContext = () => useContext(SearchWithAutocompleteContext);